import { BackgroundImage, Box, Text, Title, type BoxProps } from '@mantine/core'
import { type PropsWithChildren, type ReactNode } from 'react'

import { Container } from './Container'
import styles from './styles.module.css'

export type SectionProps = PropsWithChildren<BoxProps> & {
  withContainer?: boolean
  withBackgroundImage?: string
  title?: ReactNode
  subtitle?: ReactNode
}

export function Section({
  withBackgroundImage,
  withContainer = true,
  title,
  subtitle,
  children,
  ...props
}: SectionProps) {
  const getChildren = () => (
    <Box>
      <Title order={2} className='section-title'>
        {title}
      </Title>
      <Text size='lg' c='dimmed' className='section-subtitle'>
        {subtitle}
      </Text>
      {children}
    </Box>
  )

  const getContent = () =>
    withContainer ? (
      <Container {...props}>{getChildren()}</Container>
    ) : (
      getChildren()
    )

  if (withBackgroundImage) {
    return (
      <Box {...props}>
        <BackgroundImage
          src={withBackgroundImage ?? ''}
          className={styles.bgimage}
        />
        {getContent()}
      </Box>
    )
  }

  return getContent()
}
